import { dark } from '@clerk/themes';

type ClerkAppearanceElements = Record<string, string>;
type ClerkAppearance = {
  baseTheme?: object;
  elements?: ClerkAppearanceElements;
};

const clerkDarkTheme = dark as object;

export function getClerkAppearance(
  resolvedMode: 'light' | 'dark',
  elements?: ClerkAppearanceElements
): ClerkAppearance {
  return {
    ...(resolvedMode === 'dark' ? { baseTheme: clerkDarkTheme } : {}),
    ...(elements ? { elements } : {}),
  };
}
